import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  Shape,
  WalmartBlueLogo,
  WomanThumbsUp,
} from '../../assets/img';
import {
  KEY_FEEDBACK_SUBMITTED,
  REQUEST_STATES,
  LABELS,
  QR_LOCATIONS,
  CLUB_IDENTIFIER,
  Placeholder,
} from '../../constants/constants';
import {
  Feedback,
  Modal,
  Toast,
} from '../../components';
import { useLocation } from 'react-router-dom';
import './styles.css';
import {
  preparePayloadForStorage,
  setValueInBrowserStorage,
  getQueryParam,
  doesStringMatch,
  submitFeedback,
  getInitialRequestTimestamp,
  getValueFromBrowserStorage,
} from '../../utils';
import { useAssociateAckDetails } from '../../hooks/useAssociateAckDetails';
import useFeedbackFlow from '../shared/useFeedbackFlow';

const ThanksPage = (props) => {
  const intl = useIntl();
  const getLocaleStr = (id) => intl.formatMessage({ id });
  const location = useLocation();
  const qrLocation = getQueryParam(location.search, LABELS.LOCATION);
  const isBackroom = doesStringMatch(qrLocation, QR_LOCATIONS.Backroom);
  const prevRequestPayloadIfAny = location.state ?? {};
  const {
    isDuplicateRequest,
    qrId,
    transactionId,
    eventTimestamp,
  } = prevRequestPayloadIfAny;
  const getContent = (key, value) => <>{getLocaleStr(key).replace(Placeholder, value)}</>;
  const { club, clubLogo } = props.isCA ? { club: CLUB_IDENTIFIER.Walmart, clubLogo: WalmartBlueLogo } : { club: CLUB_IDENTIFIER.SamsClub, clubLogo: Shape };
  const [requestState, setRequestState] = useState(() => {
    if (isDuplicateRequest && prevRequestPayloadIfAny?.requestState) {
      return prevRequestPayloadIfAny.requestState;
    }
    return REQUEST_STATES.Pending;
  });
  const feedbackSubmitted = !!getValueFromBrowserStorage(KEY_FEEDBACK_SUBMITTED);
  const REQUEST_STATE_AFTER_ACK = isBackroom ? REQUEST_STATES.Trck_Delivery_On_The_Way : REQUEST_STATES.On_The_Way;
  const [associateName] = useAssociateAckDetails(transactionId, setRequestState, REQUEST_STATE_AFTER_ACK);
  const {
    active,
    setActive,
    showFeedbackModal,
    setShowFeedbackModal,
    rating,
    feedbackListOptions,
    feedbackReaction,
    isFeedbackSubmitted,
    onRatingChange,
    resetFeedbackData,
    onFeedbackSubmit,
  } = useFeedbackFlow({
    isCA: props.isCA,
    isBackroom,
    getLocaleStr,
    initialFeedbackSubmitted: feedbackSubmitted,
    submitFeedbackHandler: (starRating, cannedResponses, feedbackText) => submitFeedback(
      qrId,
      transactionId,
      starRating,
      eventTimestamp,
      cannedResponses,
      feedbackText,
    ),
  });

  useEffect(() => {
    const timestamp = getInitialRequestTimestamp(prevRequestPayloadIfAny?.timestamp, isDuplicateRequest);
    const payload = preparePayloadForStorage(qrLocation, requestState, transactionId, timestamp, eventTimestamp, associateName);
    setValueInBrowserStorage(qrId, payload, localStorage);
  }, [requestState, qrLocation, transactionId, eventTimestamp, associateName, qrId, prevRequestPayloadIfAny?.timestamp, isDuplicateRequest]);

  useEffect(() => {
    setValueInBrowserStorage(KEY_FEEDBACK_SUBMITTED, isFeedbackSubmitted);
  }, [isFeedbackSubmitted]);

  return props.isCA ? (
    <>
      <div className="container-background-ca" />
      <div className="column round-rectangle">

        <img src={WomanThumbsUp} className="large-icon-ca" alt="large-icon-ca" />

        <div className="column">
          <h3 className="roboto title-text-ca">{getContent('new_thankyou_msg', club)}</h3>
          {/* <span className="roboto typography-regular subtitle-text-ca">
            {getContent('thankyou_msg', club)}
          </span> */}
        </div>
      </div>
      {(!isFeedbackSubmitted) && (
      <div className="feedback-container">
        <Feedback
          titleStyle="typography-regular font-400 mb-12"
          title={getLocaleStr('how_was_exp')}
          starSize="20"
          numberOfStars={5}
          getLocaleStr={getLocaleStr}
          onClick={() => setShowFeedbackModal(true)}
          isCA={props.isCA}
        />
      </div>
      )}
      {showFeedbackModal && (
      <Modal
        size="stretch"
        title={getLocaleStr('give_feedback')}
        onClose={resetFeedbackData}
        isCA={props.isCA}
      >
        <div className="scroll-content-modal">
          <Feedback
            allowUserSelection
            titleStyle="typography-medium font-500 mb-16"
            starSize="46"
            title={getLocaleStr('how_was_exp')}
            getLocaleStr={getLocaleStr}
            numberOfStars={5}
            onFeedbackSubmit={onFeedbackSubmit}
            feedbackListOptions={feedbackListOptions}
            feedbackReaction={feedbackReaction}
            onRatingSelect={(selected) => onRatingChange(selected)}
            isCA={props.isCA}
          />
        </div>
      </Modal>
      )}
      {active && <Toast message={getLocaleStr(`feedback_response_${rating > 3 ? 'good' : 'bad'}`)} onHide={setActive} isCA={props.isCA} />}
    </>
  ) : (
    <div className="wrapper">
      <div id="upper" className="upperDiv">
        <div className="sams-logo__container">
          <img src={clubLogo} className="Shape" alt="Logo" />
        </div>
        {/* <ReactFloaterJs>
          <img src={MainLogo} className="mainLogo" alt="Fled" />
        </ReactFloaterJs> */}
        <span className="primaryText">
          {getContent('thankyou_msg', club)}
        </span>
      </div>
      <div id="lower" className="lowerDiv" />
    </div>
  );
};

ThanksPage.propTypes = {
  isCA: PropTypes.bool.isRequired,
};

export default ThanksPage;
